import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CrossCircle = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M17.414 16L21.707 11.707C21.888 11.526 22 11.276 22 11C22 10.448 21.552 10 21 10C20.724 10 20.474 10.112 20.293 10.293L16 14.586L11.707 10.293C11.526 10.112 11.276 10 11 10C10.448 10 10 10.448 10 11C10 11.276 10.112 11.526 10.293 11.707L14.586 16L10.293 20.293C10.112 20.474 10 20.724 10 21C10 21.552 10.448 22 11 22C11.276 22 11.526 21.888 11.707 21.707L16 17.414L20.293 21.707C20.474 21.888 20.724 22 21 22C21.552 22 22 21.552 22 21C22 20.724 21.888 20.474 21.707 20.293L17.414 16Z" />
	</svg>
);

export default CrossCircle;
